import { parseEntity } from '@/shared/converters/commonConverters';
import Chat from '../models/Chat';
import { parseChatMessages } from './chatMessageConverters';

const SCHEMA = {
  id: 'chatId',
  createdOn: 'createdOn',
  origin: 'origin',
  unreadMessages: 'unreadMessages',
  messages: (data: any) => parseChatMessages(data.messages, data.chatId),
};

export function parseChat(data: any): Chat | null {
  return parseEntity(data, SCHEMA, Chat);
}
